module.exports = __webpack_public_path__ + "static/media/2024CDSale.5810c813.png";